import { useUnit } from 'effector-react'
import groupBy from 'lodash/groupBy'
import type { UseQueryOptions } from 'react-query'
import { useQuery } from 'react-query'

import { $creatorId } from '@/models/creators.ts'

import { funnelMonitoringService } from '../service/funnel-monitoring-service'
import { type FunnelCheck, FunnelStatus } from '../types'

export const useFunnelChecksList = (
  queryOptions?: UseQueryOptions<FunnelCheck[], unknown>,
) => {
  const creatorId = useUnit($creatorId)
  const query = useQuery<FunnelCheck[]>(
    ['tracking', 'funnel', creatorId, 'list'],
    () => funnelMonitoringService.getFunnelList(creatorId!),
    {
      ...queryOptions,
      select: (data) => {
        const statusOrder = {
          [FunnelStatus.Failed]: 1,
          [FunnelStatus.Unchecked]: 2,
          [FunnelStatus.Successful]: 3,
        }

        // Group by platform
        const groupByPlatform = groupBy<FunnelCheck>(
          data,
          (item) => item.entryPointType,
        )

        // Sort by platform and then by status
        const sortedData = Object.entries(groupByPlatform)
          .sort(([keyA], [keyB]) => keyA.localeCompare(keyB))
          .map(([_, items]) =>
            items.sort((a, b) => statusOrder[a.status] - statusOrder[b.status]),
          )

        return sortedData.flat()
      },
    },
  )

  return query
}
